<template>
  <section class="marketing-section">
    <div class="marketing-section__content text-center">
      <h2 class="text-h4 font-weight-bold mb-8">Great for&hellip;</h2>

      <div class="d-flex flex-wrap justify-center ga-3">
        <v-chip
          v-for="type in eventTypes"
          :key="type"
          color="primary"
          variant="tonal"
          size="large"
          rounded="pill"
        >
          {{ type }}
        </v-chip>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const eventTypes = [
  'Rallies',
  'Caravans',
  'Boondocking Gatherings',
  'Regional Meetups',
  'Skill Swaps',
  'Workamper Meetups',
];
</script>
